import { useEffect, useState } from 'react'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { predefinedMenusSlice, predefinedState } from './PredefinedMenusSlice'

import { SelectField } from '../FormElements/FormElements'

import { useAPI } from '../../services/hoc/useAPI'



 export const RolesMenu = (props: any) => {

    // Redux
    const dispatch = useDispatch()
    const state: predefinedState = useSelector((state: { predefined_menus: predefinedState }) => state.predefined_menus)

    // Hooks
    const [isFetching, setIsFetching] = useState<boolean>(false)

    const ENDPOINTS = useAPI()

    const fetchData = () => {
        setIsFetching(true)
        ENDPOINTS.roles().index({ page: 1, page_size: 100 })
            .then((response: any) => {
                let list = response.data.data.roles.map((role: any) => ({ value: role.id, label: role.name }))
                dispatch(predefinedMenusSlice.actions.setRoles({ list }))
                setIsFetching(false)
            })
            .catch((err: any) => setIsFetching(false))


    }

    return (
        <SelectField
            {...props}
            isLoading={isFetching}
            options={state.roles.list}
         

            onMenuOpen={() => {
                if (!isFetching) {

                    fetchData()
                }

            }}
        />
    )

}


 export const EmployeesMenu = (props: any) => {

    // Redux
    const dispatch = useDispatch()
    const state: predefinedState = useSelector((state: { predefined_menus: predefinedState }) => state.predefined_menus)

    // Hooks
    const [isFetching, setIsFetching] = useState<boolean>(false)

    const ENDPOINTS = useAPI()

    const fetchData = () => {
        setIsFetching(true)
        ENDPOINTS.employees().index({ page: 1, page_size: 100, has_user: props.has_user })
            .then((response: any) => {
                let list = response.data.data.employees.map((employee: any) => ({ value: employee.id, label: employee.name }))
                dispatch(predefinedMenusSlice.actions.setEmployees({ list }))
                setIsFetching(false)
            })
            .catch((err: any) => setIsFetching(false))


    }

    return (
        <SelectField
            {...props}
            isLoading={isFetching}
            options={state.employees.list}
            onMenuOpen={() => {
                if (!isFetching) {

                    fetchData()
                }

            }}
        />
    )

}


 export const ClientsMenu = (props: any) => {

    // Redux
    const dispatch = useDispatch()
    const state: predefinedState = useSelector((state: { predefined_menus: predefinedState }) => state.predefined_menus)

    // Hooks
    const [isFetching, setIsFetching] = useState<boolean>(false)

    const ENDPOINTS = useAPI()

    const fetchData = () => {

        ENDPOINTS.clients().index({ page: 1, page_size: 5000 })
            .then((response: any) => {
                let list = response.data.data.clients.map((client: any) => (
                    { value: client.id, label: client.name, phoneNumber: client.phone, address: client.address_1, client: client }))
                dispatch(predefinedMenusSlice.actions.setClients({ list }))
                setIsFetching(false)
            })
            .catch((err: any) => setIsFetching(false))

    }

    return (
        <SelectField
            {...props}
            isLoading={isFetching}
            options={props.clients_list ? props.client_list : state.clients.list}
            onMenuOpen={() => {
                if (!isFetching && !props.clients_list) {
                    setIsFetching(true)
                    fetchData()
                }

            }}
        />
    )

}


 export const SuppliersMenu = (props: any) => {

    // Redux
    const dispatch = useDispatch()
    const state: predefinedState = useSelector((state: { predefined_menus: predefinedState }) => state.predefined_menus)

    // Hooks
    const [isFetching, setIsFetching] = useState<boolean>(false)

    const ENDPOINTS = useAPI()

    const fetchData = () => {

        ENDPOINTS.suppliers().index({ page: 1, page_size: 100 })
            .then((response: any) => {
                let list = response.data.data.suppliers.map((supplier: any) => ({ value: supplier.id, label: supplier.name }))
                dispatch(predefinedMenusSlice.actions.setSuppliers({ list }))
                setIsFetching(false)
            })
            .catch((err: any) => setIsFetching(false))


    }

    return (
        <SelectField
            {...props}
            isLoading={isFetching}
            options={state.suppliers.list}
            onMenuOpen={() => {
                if (!isFetching) {
                    setIsFetching(true)
                    fetchData()
                }

            }}
        />
    )

}






 export const OrdersMenu = (props: any) => {

    // Redux
    const dispatch = useDispatch()
    const state: predefinedState = useSelector((state: { predefined_menus: predefinedState }) => state.predefined_menus)

    // Hooks
    const [isFetching, setIsFetching] = useState<boolean>(false)

    const ENDPOINTS = useAPI()

    const fetchData = (client_name: string) => {

        ENDPOINTS.orders().index({ page: 1, page_size: 100, keyword: client_name })
            .then((response: any) => {
                let list = response.data.data.orders.filter((ele: any) => ele.client_name === props.client_name).map((order: any) => ({ value: order.id, label: order.order_no, order: order }))
                dispatch(predefinedMenusSlice.actions.setOrders({ list }))
                setIsFetching(false)
            })
            .catch((err: any) => setIsFetching(false))


    }
    useEffect(() => {
        if (props.client_name) {
            //fetchData(props.client_name)
        }
    }, [props.client_name])

    return (
        <SelectField
            {...props}
            isLoading={isFetching}
            options={state.orders.list}
            onMenuOpen={() => {
                if (!isFetching && props.client_name) {
                    setIsFetching(true)
                    fetchData(props.client_name)
                }

            }}
        />
    )

}



 export const ExpensesTypeMenu = (props: any) => {

    // Redux
    const dispatch = useDispatch()
    const state: predefinedState = useSelector((state: { predefined_menus: predefinedState }) => state.predefined_menus)

    // Hooks
    const [isFetching, setIsFetching] = useState<boolean>(false)

    const ENDPOINTS = useAPI()

    const fetchData = () => {

        ENDPOINTS.expensesType().index({ page: 1, page_size: 5000 })
            .then((response) => {
                let list = response.data.data.expensetypes.map((client) => (
                    { value: client.id??-1, label: client.expense??'',...client}))
                dispatch(predefinedMenusSlice.actions.setExpensesType({ list }))
                setIsFetching(false)
            })
            .catch((err: any) => setIsFetching(false))

    }

    return (
        <SelectField
            {...props}
            isLoading={isFetching}
            isClearable={true}
             styles={{
             clearIndicator: (base:any) => ({
                    ...base,
                    cursor: "pointer",
                    }),
                }}
            options={state.expenses_type.list}
            onMenuOpen={() => {
                if (!isFetching && !props.clients_list) {
                    setIsFetching(true)
                    fetchData()
                }

            }}
        />
    )

}
